import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { spacing } = theme;

export const root = css`
  display: flex;
  margin-bottom: ${spacing.md}px;
  border-radius: 12px;
  padding: ${spacing.md}px;
  background-color: var(--brand-bluple-10);
  color: var(--neutral-black-70);

  img {
    margin-right: ${spacing.md}px;
  }
`;
